import iosLogo   from '../../assets/iosLogo.svg';
import androidLogo  from '../../assets/androidLogo.svg';


const Assets = {
    iosLogo,
    androidLogo
}

export default Assets;